<template>
  <div v-if="datas" class="intractable-disease-page col-block width-full">
    <div class="intractable-disease-main-container col-block width-full">
      <div class="intractable-disease-main-block">
        <div class="intractable-disease-select-container col-block width-full">
          <div class="intractable-disease-select-title-container row-block">
            <div class="intractable-disease-select-title">{{ $t('COMPONENT.case.intractableDisease.select.___title') }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="intractable-disease-select-option-container row-block">
            <button class="main-button circle-button" @click="e => openIntractableDiseaseSelect()">
              <span>{{ $t('COMMON.button.___add') }}</span>
            </button>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div class="intractable-disease-switch-container col-block width-full">
          <div class="intractable-disease-switch-title-container row-block">
            <div class="intractable-disease-switch-title">{{ $t('COMPONENT.case.intractableDisease.switch.___title') }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div class="intractable-disease-switch-option-container row-block">
            <div class="intractable-disease-switch-option-title">{{ $t('COMPONENT.case.base.customForm.reportPhenovardb.___off') }}</div>
            <switchButton
              :disabled="false"
              :checked="analysisSwitch"
              @input="c => { analysisSwitch = c }"
            ></switchButton>
            <div class="intractable-disease-switch-option-title active">{{ $t('COMPONENT.case.base.customForm.reportPhenovardb.___on') }}</div>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div :style="{ flex: 1 }"></div>
        </div>
      </div>
      <div v-if="datas.length" class="intractable-disease-select-result-container col-block width-full">
        <div class="intractable-disease-select-result-title-container row-block">
          <div class="intractable-disease-select-result-title">{{ $t('COMPONENT.case.intractableDisease.selectResult.___title') }}</div>
          <div :style="{ flex: 1 }"></div>
        </div>
        <div class="intractable-disease-select-result-item-container col-block width-full">
          <div class="intractable-disease-select-result-item-list-container row-block flex-start flex-wrap">
            <div class="intractable-disease-select-result-item-block row-block" v-for="(data, dindex) in datas" :key="dindex" @click="e => dataOnSelect(data)">
              <img
                class="intractable-disease-select-result-item-icon"
                :src="selecteds.some(selected => selected.value === data.value) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')"
              >
              <div class="intractable-disease-select-result-item-title">{{ $t(data.title) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import switchButton from '../tool/switchButton.vue'

export default {
  components: {
    switchButton
  },
  props: {
    defaultDatas: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      datas: null,
      analysisSwitch: true,
      selecteds: null
    }
  },
  computed: {
    ...mapGetters([
      'modal'
    ]),
    sendData () {
      return {
        datas: this.selecteds,
        analysisSwitch: this.analysisSwitch
      }
    }
  },
  watch: {
    'defaultDatas' (nv, ov) {
      if (nv !== ov) {
        this.init(nv)
      }
    },
    'sendData' (nv) {
      this.$emit('change', nv)
    }
  },
  created () {
    this.init(this.defaultDatas)
  },
  methods: {
    ...mapActions([
      'setModalAction',
      'setModal2Action'
    ]),
    init (defaultData) {
      let datas = defaultData.datas || []
      this.datas = datas
      this.selecteds = datas
      this.analysisSwitch = ![null, undefined].includes(defaultData.analysisSwitch) ? defaultData.analysisSwitch : this.analysisSwitch
    },
    dataOnSelect (data) {
      if (this.selecteds.some(selected => selected.value === data.value)) {
        this.selecteds.splice(this.selecteds.indexOf(data), 1)
      } else {
        this.selecteds.push(data)
      }
    },
    openIntractableDiseaseSelect () {
      let action = this.modal.action ? this.setModal2Action : this.setModalAction
      action({
        action: 'intractableDiseaseSelect',
        width: '1208px',
        height: 'calc(100% - 160px)',
        param: {
          selectedDatas: this.selecteds
        },
        callback: async result => {
          if (result) {
            let selectedDatas = result
            selectedDatas.forEach(selectedData => {
              if (!this.datas.some(data => data.value === selectedData.value)) {
                this.datas.push(selectedData)
              }
              if (!this.selecteds.some(selected => selected.value === selectedData.value)) {
                this.selecteds.push(selectedData)
              }
            })
          }
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/case/intractableDisease.vue